import { fetchAuthSession } from 'aws-amplify/auth';

const API_URL = process.env.REACT_APP_API_URL;

async function getAuthHeaders() {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
}

export const getPendingAccessRequests = async () => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${API_URL}/api/admin/requests`, {
    headers
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch requests');
  }
  
  return await response.json();
};

export const approveAccessRequest = async ({ requestId, approved, groupName, personalizedMessage }) => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${API_URL}/api/admin/requests/${requestId}/approve`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ approved, groupName, personalizedMessage })
  });
  
  if (!response.ok) {
    throw new Error('Failed to process request');
  }
  
  return await response.json();
};

export const getPendingVisits = async () => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${API_URL}/api/admin/visits/pending`, {
    headers
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch visits');
  }
  
  return await response.json();
};

export const moderateVisit = async ({ visitId, approved }) => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${API_URL}/api/admin/visits/${visitId}/moderate`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ approved })
  });
  
  if (!response.ok) {
    throw new Error('Failed to moderate visit');
  }
  
  return await response.json();
};

export const createStone = async (stoneData) => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${API_URL}/api/admin/stones`, {
    method: 'POST',
    headers,
    body: JSON.stringify(stoneData)
  });
  
  if (!response.ok) {
    throw new Error('Failed to create stone');
  }
  
  return await response.json();
};

export const getUploadUrl = async ({ fileName, fileType, visitId }) => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${API_URL}/api/upload-url`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ fileName, fileType, visitId })
  });
  
  if (!response.ok) {
    throw new Error('Failed to get upload URL');
  }
  
  return await response.json();
};

export const completeStoneUpload = async ({ stoneId, placingVisitId, mediaFiles }) => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${API_URL}/api/admin/stones/complete-upload`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ stoneId, placingVisitId, mediaFiles })
  });
  
  if (!response.ok) {
    throw new Error('Failed to complete stone upload');
  }
  
  return await response.json();
};